import React from "react";
import { Accordion, Tabs, Tab, Spinner } from "react-bootstrap";
import "./ViewInterviewVideo.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faArrowLeftLong,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../Header";
import useViewInterviewVideo from "./useViewInterviewVideo";
import VideoPlayer from "../../../_uiComponents/VideoPlayerBasic";
import StarRatings from "react-star-ratings";
import MainLayout from "../MainLayout";
function ViewInterviewVideo(props) {
  const {
    userMeta,
    interviewPlayBackId,
    interviewQuestions,
    question,
    videoPlayBackDuration,
    questionIndex,
    loading,
    sidebarCollapsed,
    hmsRoomDetail,
    toggleSideBar,
    onBackClick,
    onNextPrevClick,
    onQuestionViewClick,
    onLoginClick,
    onQuestionRatingChange,
    getJoineesNames,
  } = useViewInterviewVideo(props);

  return (
    <>
      <MainLayout pageName={"One to One Videos"}>
        <div className="view-assessment-video">
          <div className="container">
            {loading ? (
              <div className="p-5 text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : userMeta?.id ? (
              <div className="view-interview-wrapper">
                <div className="player-wrapper">
                  <div className="row flex-grow-1">
                    <div className="interview-video col-lg-8">
                      <div className="border bg-white rounded-lg p-3 shadow-2 mt-3 mb-md-4">
                        <div className="d-flex flex-wrap align-items-center flex-md-nowrap border-bottom pb-2 mb-4">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              onClick={onBackClick}
                              className="text-primary mr-3 cursor-pointer h2 mb-0"
                              icon={faAngleLeft}
                            />{" "}
                          </div>
                          <div className="ml-2 flex-grow-1">
                            <h3 className="w-100 p-1 rounded mb-0">
                              One to One interview between{" "}
                              <span className="text-capitalize">
                                {hmsRoomDetail?.mentor &&
                                  hmsRoomDetail?.mentor?.full_name}
                              </span>{" "}
                              and{" "}
                              <span className="text-capitalize">
                                {hmsRoomDetail?.candidate &&
                                  hmsRoomDetail?.candidate?.full_name}
                              </span>
                            </h3>
                          </div>
                        </div>

                        {Array.isArray(interviewQuestions) &&
                        interviewQuestions.length ? (
                          <div className="question-wrapper mb-4  d-flex  justify-content-center mt-2 text-grey-1">
                            <button
                              className="btn btn-primary mr-3"
                              onClick={() =>
                                onNextPrevClick(question?.id, "sub")
                              }
                              disabled={
                                questionIndex === 0 ||
                                typeof questionIndex === "object"
                              }
                            >
                              <FontAwesomeIcon icon={faAngleLeft} />
                            </button>
                            <p className="border rounded bg-grey p-3 mr-2 d-flex justify-content-center flex-wrap font-weight-medium mb-0">
                              {typeof questionIndex === "object" &&
                              questionIndex !== null ? (
                                <>
                                  {0}/{interviewQuestions.length}
                                </>
                              ) : (
                                <>
                                  {questionIndex + 1}/
                                  {interviewQuestions.length}
                                </>
                              )}
                              :{" "}
                            </p>
                            <p className="border rounded bg-grey mr-2 p-3 d-flex flex-grow-1 justify-content-center flex-wrap font-weight-medium mb-0">
                              {question?.question
                                ? question?.question
                                : "Select Question"}
                            </p>

                            <button
                              className="btn btn-primary ml-3"
                              disabled={
                                questionIndex === interviewQuestions.length - 1
                              }
                              onClick={() =>
                                onNextPrevClick(question?.id, "add")
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                            </button>
                          </div>
                        ) : null}

                        <div className="video-wrapper rounded-lg">
                          <VideoPlayer
                            playbackId={interviewPlayBackId}
                            playBackDuration={videoPlayBackDuration}
                            isAutoPlay={true}
                          />
                        </div>
                      </div>
                    </div>

                    {question?.question && (
                      <div className="col-lg-4 mt-3 mb-4 mb-md-4">
                        <div className="border bg-white rounded-lg p-3 shadow-2 h-100 mb-md-4">
                          <div className="question-panel position-relative">
                            <h3 className="mb-2 fs-20 text-capitalize">
                              Evaluation
                            </h3>
                            <p className="text-grey-4 mb-3">Mentor</p>
                            <p className="font-weight-500 mr-2 fs-14 font-weight-medium text-grey-1">
                              Question Response Rating
                            </p>
                            <div className="d-flex flex-wrap align-items-center justify-content-between pb-4">
                              <p className="bg-grey px-2 my-1 rounded mb-0 text-capitalize fs-smallest">
                                {question?.skill_tag && question.skill_tag[0]}
                              </p>

                              {userMeta?.role === "mentor" ? (
                                <>
                                  <StarRatings
                                    rating={
                                      question?.rating === null
                                        ? 0
                                        : question?.rating
                                    }
                                    starRatedColor="#ffc400"
                                    changeRating={(e) =>
                                      onQuestionRatingChange(e)
                                    }
                                    numberOfStars={5}
                                    name="rating"
                                    starDimension="24"
                                    starHoverColor="#FCDDB0"
                                  />
                                </>
                              ) : (
                                <>
                                  {question?.rating &&
                                  question.rating?.rating ? (
                                    <StarRatings
                                      rating={
                                        question?.rating &&
                                        question.rating?.rating === null
                                          ? 0
                                          : question?.rating &&
                                            question.rating?.rating
                                      }
                                      starRatedColor="#FFCC2A"
                                      numberOfStars={5}
                                      name="rating"
                                      starDimension="24"
                                      starHoverColor="#FCDDB0"
                                    />
                                  ) : (
                                    <p className="fs-smallest text-danger mb-0">
                                      No Rating Given!
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center rounded-lg border flex-wrap mb-0">
                <p className="question font-weight-medium mb-0">
                  Login to view one on one Interview Videos.
                </p>
                <button className="btn btn-primary" onClick={onLoginClick}>
                  Login
                </button>
              </div>
            )}
          </div>
        </div>
      </MainLayout>
    </>
  );
}
export default ViewInterviewVideo;
